
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"26","height":"26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"26","height":"26","rx":"4","fill":"#008C89","fill-opacity":".16"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.75 15.188c0-.242.196-.438.438-.438h2.624a.438.438 0 010 .875H8.188a.438.438 0 01-.438-.438zM7.75 12.563c0-.242.196-.438.438-.438h6.124a.438.438 0 010 .875H8.189a.438.438 0 01-.438-.438zM7.75 9.938c0-.242.196-.438.438-.438h9.624a.438.438 0 010 .875H8.188a.438.438 0 01-.437-.438z","fill":"#008C89"}})])
          )
        }
      }
    